<template>
<div>
        <div class="gannue columns">
        <h2>尾矿库自动化监测</h2>
        <div class="all">
          <p>
              尾矿库是金属与非金属矿山安全生产的重要环节，也是该领域的重大危险源之一，作为具有高势能的人造泥石流危险源，其一旦发 生事故，不仅会给下游人民生命财产安全造成巨大损失，更会给当地环境造成严重污染，从而对当地的经济发展和社会稳定也带来 严重的负面影响。
          </p>
        </div>
        <div class="brief_box">

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>项目基本情况</h5>
            </div>
            <p>对尾矿库的坝体、干滩、水体进行监测，为尾矿库的安全维护提 供支持。</p>
             
              <div class="title_box row">
                <div class="blue_line"></div>
                <h5>监测参数</h5>
            </div>
            <p>坝体表面位移（GNSS/测量机器人）</p>
            <p>坝体深层位移（多点位移计）</p>
            <p>浸润线（渗压计）</p>
            <p>库水位（扬压力计）</p>
            <p>应力应变（应力计/应变计）</p>
            <p>降雨量（雨量计）</p>
            <p>干滩监测（视频系统）</p>
            <p>地震（加速度传感器）</p>

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>推荐设备</h5>
            </div>
            <p>监测设备：</p>
            <p>RocBox RT2000-GS北斗监测GNSS</p>
            <p>RT2000-GA005监测天线</p>
            <p>Topcon MS系列测量机器人</p>
            <p>Topcon DS系列测量机器人</p>
            <p>RT-VW-3100振弦式渗压计</p>
            <p>RT-DT-3100投入式水位计</p>
            <p>RT-VW-4300振弦式多点位移计</p>
            <p>RT-VW-2400振弦式土压力计</p>
            <p>RT-DT-8100系列多参数气象站</p>
            <p>低频测振传感器</p>
            
            <h6>监测终端:</h6>
            <p>RocBox RT2000监测终端</p> 
            <p>RocMIoT监测物联网系列产品</p>  
            <p>振动信号采集仪</p>  
</p>              
        </div>    
    </div>
     <foot></foot>

</div>

</template>
<style>
.gannue {
  width: 100%;
  background-color: rgba(245, 245, 245, 1);
}
h2 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  margin-top: 0.55rem;
  margin-bottom: 0.36rem;
}
.all {
  width: 11.4rem;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin: 0 auto;
  padding: 0.3rem;
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
}
.brief_box {
  width: 12rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin-top: 0.2rem;
  margin-bottom: 0.67rem;
  padding-bottom: .64rem;
}
.brief_box p,
 .brief_box h6{
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-left: 0.4rem;
  padding-top: 0.1rem;
}
.brief_box h6{
    padding-top: .3rem;
}
.title_box {
  margin-left: 0.4rem;
  margin-top: 0.37rem;
  font-size: 0.16rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  line-height: 0.2rem;
}
.blue_line {
  width: 0.03rem;
  height: 0.2rem;
  background: rgba(67, 148, 208, 1);
  margin-right: 0.1rem;
}
</style>

<script>
import footer from "../../common/footer";
export default {
  data() {
    return {};
  },
  components: {
    foot: footer
  }
};
</script>



// WEBPACK FOOTER //
// src/homepages/solutionpage/gannue.vue